import React, { useState } from 'react';
import { experiences } from '../data/experiences';

export default function Experience() {
  const [activeCompany, setActiveCompany] = useState('Northbridge Insurance');

  return (
    <section id="Experience" className="experience-section">
      <div className="experience-container fade-in-visible">
        <div className="experience-title">
          <span className="text-content">Experience</span>
        </div>

        <div className="experience-content">
          <div className="company-list">
            {Object.keys(experiences).map((company) => (
              <button
                key={company}
                className={`company-tab ${activeCompany === company ? 'active' : ''}`}
                onClick={() => setActiveCompany(company)}
              >
                {company}
              </button>
            ))}
          </div>

          <div className="job-details">
            {experiences[activeCompany].roles.map((role, index) => (
              <div key={index} className="job-role">
                <div className="job-header">
                  <h3 className="job-title">{role.title}</h3>
                  <p className="job-period">{role.period}</p>
                </div>

                <div className="job-responsibilities">
                  {role.responsibilities.map((responsibility, rIndex) => (
                    <div key={rIndex} className="responsibility-item">
                      <span className="bullet">▷</span>
                      <p>{responsibility}</p>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
